<template lang="html">
  <div class="dib user-select-none w-100">
    <div v-if="title" class="b mb3 ph4 ph0-ns">{{ title }}</div>
    <div
      v-for="(option, index) in options"
      :key="option.slug"
      @click="option.active = !option.active"
      :class="checkItemClass(index)"
    >
      <i v-if="option.active" class="material-icons v-mid mr2 mr1-ns">check_box</i>
      <i v-else class="material-icons v-mid mr2 mr1-ns">check_box_outline_blank</i>
      <span class="v-mid font-futura-bold">{{ option.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'options',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    responsive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    checkItemClass(index) {
      let classArray =
        ['pointer', 'hover-bg-highlight', 'pv1', 'br2', 'nowrap'];
      if (this.responsive) {
        classArray = [
          'pointer', 'hover-bg-highlight', 'ph4', 'pv3', 'nowrap',
          'bb', 'bg-white', 'b--moon-gray',
          'br2-ns', 'bn-ns', 'pv1-ns', 'ph1-ns', 'nl1-ns'
        ];
        if (index === 0) classArray.push('bt');
      }
      return classArray;
    }
  }
};
</script>

<style lang="scss" scoped>
.material-icons {
  margin-left: -2px;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckList.vue